import { Button, Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CampignIntroComponent from '../../components/Brand/CampignIntroComponent';
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import { useGlobalState } from '../../store/state';

export const BrandHomePage = () => {
  const history = useHistory();
  const [company] = useGlobalState('company');
  const [user] = useGlobalState('user');
  console.log(company, user);
  useEffect(() => {
    if (user && !user.opt_verified) {
      console.log('user not verified', user);
      history.push('/brand/validate-otp');
    } else if (!company.selected) {
      history.push('/brand/create-company');
    } else {
      history.push('/brand/'+company.selected.id);
    }
  }, [company.selected]);
  return (
    <BrandBaseLayoutComponent>
      <BrandTopSubHeaderComponent className="p-3 sticky">
                Welcome!
      </BrandTopSubHeaderComponent>
      <div>
        <Row gutter={16}>
          <Col span={14}>
            <CampignIntroComponent
              title="This is your new space to grow your Brand"
              subtext="Create campiagn to promote your brand with our digital Influencers"
              image="/images/campaign-intro.svg"
              colSize={7}
            >
              {/* <Link to="/brand/campaign/create" className="common_button">Create Campaign</Link> */}
            </CampignIntroComponent>
          </Col>
          <Col span={10}>
            <CampignIntroComponent
              title="Buy Credits"
              subtext="You need to buy credits to reach out our influencers"
              image="/images/wallet.svg"
              colSize={6}
            >
              {/* <Link className="common_button">Add Credits</Link> */}
            </CampignIntroComponent>
          </Col>
        </Row>
        <div className="row">
          <div className="col-md-6">
            <h4>Your Campaigns</h4>
          </div>
          <div className="col-md-6">
            <Button className="common_button">View All Campaigns</Button>
          </div>
        </div>
      </div>
    </BrandBaseLayoutComponent>
  );
};
